import { IconLanguage } from '@components/icons/language';
import { FilterConfigField } from '@components/table';
import { FilterData } from '@components/table/filters';
import { CareerSiteLanguageType } from '@locale/locale-store';

import { useTranslate } from 'locale';
import { useStore } from 'models/Provider';

const languageFieldToExternalQuery = (filter: FilterData) => {
  switch (filter.comparer) {
    case 'is':
    case 'any_of':
      return { language: filter.value };
    case 'not_is':
    case 'none_of':
      return { language__exclude: filter.value };
    default:
      return {};
  }
};

export const useLanguageFilter = (): FilterConfigField | null => {
  const { current } = useStore();
  const { t } = useTranslate();

  const langs: Array<CareerSiteLanguageType> = current.info.langs;

  if (langs.length <= 1) return null;

  return {
    id: 'language',
    label: t('applicants.filters.language.label'),
    icon: <IconLanguage />,
    type: 'multi_select',
    values: langs.map((lang) => ({
      value: lang,
      label: t(`core.language.${lang}`),
    })),
    quick: langs.map((lang) => ({
      id: lang,
      label: t(`core.language.${lang}`),
      apply: { comparer: 'is', value: lang },
    })),
    allowedComparers: ['is', 'not_is', 'any_of', 'none_of'],
    toExternalQuery: languageFieldToExternalQuery,
  };
};
